import React from "react";

import { useSiteData } from "../../contexts/SiteDataContext";
import RegionSwitch from "../RegionSwitch/RegionSwitch";
// import FooterLinks from "../FooterLinks/FooterLinks";

function Footer() {
  const { siteData } = useSiteData();

  const showRegionSwitch = siteData?.siteConfig?.show_region_switch;

  return (
    <footer className="w-full bg-dark text-white">
      <div className="container-lg 2xl:px-0 px-5 pt-16 pb-12 lg:pt-23 lg:pb-32 flex flex-wrap flex-col lg:flex-row gap-7 lg:gap-0 justify-between mx-auto">
        <div className="w-full lg:w-1/2 text-white pb-30 lg:pb-0 leading-[120%]">
          <div className="font-extrabold text-2xl mb-3 lg:text-3xl">
            {siteData?.footer_have_questions?.title}
          </div>
          <div className="text-xs font-medium lg:text-2xl md:mb-11 mb-6">
            {siteData?.footer_ask_us?.title}
          </div>
          {showRegionSwitch && <RegionSwitch />}
        </div>
        <div className="w-full lg:w-1/4 text-white">
          <a
            target="_blank"
            href="https://t.me/vpn_ru_net_bot"
            className="button block cursor-pointer font-extrabold border-[0.1875rem] rounded-lg border-r-12 text-center p-[1rem] md:p-[1.5rem] text-[0.875rem] md:text-[1.125rem] "
            rel="noreferrer"
            data-umami-event="Footer Bot Click"
          >
            {siteData?.footer_feedback_bot?.title}
          </a>
        </div>
      </div>

      <div className="container-lg 2xl:px-0 px-5 pb-16 lg:pb-30 flex flex-wrap flex-col lg:flex-row gap-7 lg:gap-0 mx-auto text-sm font-normal leading-[150%] text-light-custom">
        <div className="w-full lg:w-1/2 pb-30 lg:pb-0">
          <div
            dangerouslySetInnerHTML={{
              __html: siteData?.copyright?.content ?? "",
            }}
          />
        </div>
        <div className="w-full lg:w-1/2">{/* <FooterLinks /> */}</div>
      </div>
    </footer>
  );
}

export default Footer;
